// React
import { useEffect, useState } from "react"

// Types
import type { AccountGroupType, SuccessFetch } from "../../types"

// Utils
import { useApi } from "./useApi"

export function useAccountGroup() {
  // Hooks
  const api = useApi()
  const [data, setData] = useState<AccountGroupType[]>([])
  const [isLoading, setLoading] = useState(true)

  useEffect(() => {
    api.get("/groupcoa/").then((res: SuccessFetch<{
      payload: {
        group_coa_code: string
        group_coa_id: number
        group_coa_name: string
        group_coa_type: 1 | 2
      }[]
    }>) => {
      setData(res.data.payload.map(item => {
        // Vars
        const type = {
          1: "Balance",
          2: "Profit and Lose"
        }

        return {
          group_coa_code: item.group_coa_code,
          label: item.group_coa_name,
          report_type: type[item.group_coa_type],
          value: item.group_coa_id.toString()
        }
      }))
    }).catch(() => {
      setData([])
    }).finally(() => {
      setLoading(false)
    })
  
    return () => {
      setData([])
      setLoading(true)
    }

    // eslint-disable-next-line
  }, [])

  return { data, isLoading }
}